var _$data_17={version:"0.27.2"};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRhdGEuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsInZlcnNpb24iXSwibWFwcGluZ3MiOiJBQUFBQSxhQUFPQyxDQUFVLENBQ2ZDLE9BQUFBLENBQVcsUUFBQSxDQUFBLENBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==